var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 512 512",
    fill: "#333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.2 98.1c-7.2 2.8-14.4 10.1-17.2 17.6-1.8 4.7-2.1 7.3-1.8 13.8.3 4.4.8 8.8 1.2 9.7.6 1.4.3 1.8-1.4 1.8-10.2 0-42.4 9.8-60.2 18.3-64.3 30.6-109.5 92.1-119.2 162.2l-1.3 9.5h425l-.6-6.3c-1.7-18.2-9.6-45.2-19-64.9-24.5-51.5-68.8-91-122.9-109.6-11.9-4.2-32.4-9.2-37.3-9.2-2.2 0-2.6-.3-1.9-1.8.4-.9.9-5.3 1.2-9.7.5-10.6-2-17.6-8.8-24.5-8.9-8.8-23.5-11.6-35.8-6.9zm6.8 85.4c5.8 3 6.9 10.7 2.2 15.5-2.4 2.3-3.9 2.9-10.3 3.5-55.6 5.2-105 42-124.9 93-1.7 4.4-4.2 9-5.6 10.2-3.5 3.2-9.7 3.1-12.9-.1-5.1-5.1-4.4-9.2 4.6-28.1 15.4-32.3 44.4-61.8 76.8-77.9 15.5-7.7 33.4-13.5 49.6-16 12.1-1.9 17-1.9 20.5-.1zM2.9 354.9c-4.5 4.5-4.1 10.1 1.4 19.2 11.5 19.3 31.1 33.8 53.5 39.5l9.5 2.4h377.4l9.5-2.4c22.4-5.7 42-20.2 53.5-39.5 5.5-9.1 5.9-14.7 1.4-19.2l-2.9-2.9H5.8l-2.9 2.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.49836ce36d11fe279c824bcb97b4fc2b.svg";
export { ForwardRef as ReactComponent };